<template>
     <el-dialog  title="banner信息" :visible.sync="showBlock" :close-on-click-modal="false"   :destroy-on-close="true" width='630px' :before-close="closedBtn">
      <div class="root">
        <el-form :model="fromData" ref="fromData" label-width="100px" class="demo-ruleForm">
            
            <el-form-item  label="banner位置">
                {{ banner.bannerName }}
            </el-form-item>
            <el-form-item  label="尺寸xW(px)">
                {{ banner.domMessage.width+' * '+ banner.domMessage.height }}
            </el-form-item>
            <el-form-item  label="banner标题"  prop="name">
                <el-input v-model="banner.addParam.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item  label="URL"  prop="name">
              <el-input v-model="banner.addParam.linkUrl" placeholder="请输入URL"></el-input>
            </el-form-item>
            <el-form-item  label="排序"  prop="name">
              <el-input-number v-model="banner.addParam.priority" :min="banner.defaultNum" label="请输入排序"></el-input-number>
              <!-- <el-input type="number" v-model="banner.addParam.priority" placeholder="请选择排序"></el-input> -->
            </el-form-item>
            <el-form-item  label="上传图片"  prop="url">
              <!--  @getUpload="announcement.getUpload" -->
              <UpLoadImng @before-upload="banner.getImgMessage" @getUpload="banner.getImg" ref="uplaodimg" width="76" height="76" :showMark="false" size="1" keyVal="background" limit="1" rules="jpg,gif,png" />
            </el-form-item>
            <el-form-item>
                <div class="warp-BTn dialog-footer">
                    <el-button @click="closedBtn">取消</el-button>
                    <el-button type="primary" @click="submit">提交</el-button>
                </div> 
            </el-form-item>
        </el-form>
      </div>
     </el-dialog>
</template>

<script>
import UpLoadImng from '@/components/component-block/block-uploadImg.vue'
export default {
  components:{
    UpLoadImng
  },
  props:{
    banner:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      showBlock: false,
      bannerObj:{},
      // banner:{
      //   getImgMessage:() =>{},
      //   getImg:()=>{},
      //   domMessage:{
      //     width:"",
      //     height:''
      //   }
      // },
      fromData:{},
      operty:'',
      obj:''
    };
  },
  methods: {
    open(param,operty,obj){
      this.banner.setHomeThis(this);
      // this.banner = param.banner;
      this.obj = obj;
      console.log('dai',operty)
      this.operty = operty;
      this.showBlock = true;
      if(this.operty == 'edit'){
        this.banner.domMessage.height = obj.height;
        this.banner.domMessage.width = obj.width;
        this.banner.blId = obj.blId;
        this.banner.addParam.title = obj.title;
        this.banner.addParam.linkUrl = obj.linkUrl;
        this.banner.addParam.priority = obj.priority;
        this.banner.addParam.resource = obj.resource;

        let param = {
          defaultVal:[{url:this.obj.resourceUrl}],
          defaultImg:[this.obj.resource]
        }
      
        console.log('测试',param);

        this.$refs.uplaodimg.setVal(param)
      }
    },
    closedBtn(){
      console.log('guanb-------')
      this.showBlock = false;
      this.banner.setDefault();
    },
    submit(){
      if(this.operty == 'add'){
        console.log('增加',this.banner.addParam)
        this.banner.addBanner(this);
      }
      else if(this.operty == 'edit'){
        this.banner.editBanner(this,this.obj)
      }
    }
  }
}
</script>

<style>

</style>